/* eslint-disable react/no-danger */
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import ReactImageZoom from 'react-image-zoom';
import { Link } from 'react-router-dom';

import Layout from '../layout';
import URLSanitizer from '../../services/url-sanitizer';
import ProductModel from '../../services/product-model';
import ThumbnailList from '../product/thumbnail-list';
import { priceFormat } from '../../helper';
import APP_ROUTES from '../../constants/app-routes';

import noImage from '../../images/no-image.png';

import styles from '../styles/pages/product-show.scss';
import loadingStyles from '../styles/components/loading.scss';
import CategoryBadge from '../product/category-badge';
import ProductDetailsQuantitySelector from '../product/product-details-quantity-selector';
import VariantSelector from '../product/variant-selector';
import ExtraDataModal from '../product/extra-data-modal';

const img = new Image();

class ProductShow extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentProduct: {},
            currentVariant: null,
            currentImage: '',
            imageNo: 0,
            imageThumbs: [],
            images: [],
            currentPrice: '',
            defaultImage: false,
            showZoom: false,
            loadingImage: true,
            reviews: 0,
            rating: 0,
            dataExtraType: null,
            showExtraDataModal: false,
            extraDataInfo: {},
        };

        this.onChangeVariant = this.onChangeVariant.bind(this);
        this.toggleShowZoom = this.toggleShowZoom.bind(this);
        this.addReview = this.addReview.bind(this);
        this.onClickThumbnail = this.onClickThumbnail.bind(this);
        this.loadProductFromAPI = this.loadProductFromAPI.bind(this);
    }

    componentDidMount() {
        // TODO
        // The wrong url error was that triggerInitialSetup now receives only 2 params and we were passing 3 then the
        // first argument was the path name instead of the locale.
        //
        // Why to load all products in show??? It even shows the loader with this line commented.
        //
        // this.props.triggerInitialSetup(this.props.locale.currentLocale, this.props.products);

        const { productId } = this.props.match.params;
        const product = ProductModel.findBySlug(productId, this.props.products);
        if (product) {
            const images = this.filterDuplicatedImages(this.getGenericImagesFromProduct(product).concat(product.master.images));
            this.preloadImages(images);

            const masterPrice = product && product.attributes && product.master.attributes && product.master.attributes.price;

            this.setState({
                currentProduct: product,
                currentPrice: masterPrice,
                currentVariant: product.master,
                dataExtraType: product.data_extra_types,
            });
        } else {
            this.loadProductFromAPI(productId, true);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.showZoom !== this.state.showZoom || prevState.imageNo !== this.state.imageNo) {
            const zoomedArea = document.getElementById(`image-${this.state.imageNo + 1}`).getElementsByClassName('js-image-zoom__zoomed-area')[0];
            const zoomedImage = document.getElementById(`image-${this.state.imageNo + 1}`).getElementsByClassName('js-image-zoom__zoomed-image')[0];

            zoomedArea.style.opacity = !this.state.showZoom ? '0' : '0.15';
            zoomedImage.style.opacity = !this.state.showZoom ? '0' : '1';
        }

        if (prevProps.locale.currentLocale !== this.props.locale.currentLocale) {
            const { productId } = this.props.match.params;
            this.loadProductFromAPI(productId, false);
        }
    }

    onChangeVariant(variant) {
        this.setState({ currentVariant: variant, currentPrice: variant.attributes.price });
        const images = this.filterDuplicatedImages(this.getGenericImagesFromProduct(this.state.currentProduct).concat(variant.images));
        this.preloadImages(images);
    }

    onClickThumbnail(imageNo) {
        this.setState((prevState) => ({ currentImage: prevState.images[imageNo], imageNo }));
    }

    onModalResponse(response, value) {
        if (response === 'accept') {
            const extra = {};
            extra[this.state.extraDataInfo.id] = value;

            this.props.addProductToCart(
                this.state.currentVariant.id,
                this.state.extraDataInfo.quantity,
                this.props.currentZone,
                this.props.locale.currentLocale,
                this.props.order,
                this.props.access_token,
                extra,
            );
        }
        this.setState((state) => ({
            showExtraDataModal: !state.showExtraDataModal,
        }));
    }

    getCategory() {
        const { productId } = this.props.match.params;
        const product = ProductModel.findBySlug(productId, this.props.products);
        if (product.attributes && product.attributes.shipping_category && product.attributes.shipping_category.name && product.attributes.shipping_category.name !== 'Default') {
            return product.attributes.shipping_category.name;
        }
        return null;
    }

    getGenericImagesFromProduct = (product) => {
        const allImages = product.images;
        const imagesFromVariants = product.variants.map((variant) => variant.images).flat();
        console.log('images', allImages.filter((image) => imagesFromVariants.find((variantImage) => variantImage.id === image.id) === undefined));
        return allImages.filter((image) => imagesFromVariants.find((variantImage) => variantImage.id === image.id) === undefined);
    };

    filterDuplicatedImages = (images) => {
        const result = [];
        images.forEach((image) => {
            if (image.attributes
                && image.attributes.styles
                && image.attributes.styles[11]
                && image.attributes.styles[11].url
                && result.findIndex((elem) => image.attributes.styles[11].url === elem.attributes.styles[11].url) === -1
            ) {
                result.push(image);
            }
        });
        return result;
    };

    loadProductFromAPI(productId, preloadImages = true) {
        this.props.fetchProductFromAPI(productId, this.props.locale.currentLocale, this.props.currentZone, (product) => {
            const images = this.filterDuplicatedImages(this.getGenericImagesFromProduct(product).concat(product.master.images));
            if (preloadImages) {
                this.preloadImages(images);
            }

            const masterPrice = product && product.attributes && product.attributes.price;

            this.setState({
                currentProduct: product,
                currentPrice: masterPrice,
                currentVariant: product.master,
                dataExtraType: product.data_extra_types,
            });
        });
    }

    addReview() {
        this.setState((prevState) => ({ reviews: prevState.reviews + 1 }));
    }

    addProductToCart(quantity) {
        if (this.state.currentProduct.data_extra_types && this.state.currentProduct.data_extra_types[0] && this.state.currentProduct.data_extra_types[0].attributes) {
            const {
                id,
                attributes: { field_type: fieldType, is_required: isRequired, label },
            } = this.state.currentProduct.data_extra_types[0];
            this.setState((state) => ({
                showExtraDataModal: !state.showExtraDataModal,
                extraDataInfo: {
                    fieldType,
                    isRequired,
                    label,
                    id,
                    quantity,
                },
            }));
        } else {
            this.props.addProductToCart(this.state.currentVariant.id, quantity, this.props.currentZone, this.props.locale.currentLocale, this.props.order, this.props.access_token);
        }
        // if (this.props.order.id && this.props.order.store.id !== this.props.currentStore.id) {
        //     this.handleShowModalStore(this.props.order.store);
        // } else {
        // }
    }

    toggleShowZoom() {
        this.setState((prevState) => ({ showZoom: !prevState.showZoom }));
    }

    preloadImages(images) {
        let imageUrl = '';
        const defaultImage = images[0];

        if (defaultImage && defaultImage.attributes && defaultImage.attributes.styles) {
            imageUrl = URLSanitizer.makeAbsolute(defaultImage.attributes.styles[11].url);
        }

        if (imageUrl) {
            img.src = imageUrl;

            img.onload = () => {
                // when it finishes loading, update the component state
                this.setState({
                    currentImage: imageUrl || noImage,
                    loadingImage: false,
                    defaultImage: !imageUrl,
                });
            };

            const thumbs = [];
            const mainImages = [];
            images.forEach((image) => {
                thumbs.push(URLSanitizer.makeAbsolute(image.attributes.styles[3].url));
                mainImages.push(URLSanitizer.makeAbsolute(image.attributes.styles[11].url));
            });
            this.setState(() => ({
                imageThumbs: thumbs,
                images: mainImages,
            }));
        } else {
            this.setState({
                currentImage: noImage,
                loadingImage: false,
                defaultImage: true,
            });
        }
    }

    render() {
        const { currentProduct, currentVariant, images } = this.state;
        const { intl } = this.props;

        const productName = currentProduct && currentProduct.attributes && currentProduct.attributes.name;

        if (productName) {
            document.title = productName;
        }

        const productDescription = currentProduct && currentProduct.attributes && currentProduct.attributes.description;

        const productNotes = currentProduct && currentProduct.attributes && currentProduct.attributes && currentProduct.attributes.notes;

        const productAgeValid = currentProduct && currentProduct.attributes && currentProduct.attributes.age_valid;

        const imageList = images.map((image, idx) => (
            <li
                key={`image-${idx}`}
                id={`image-${idx + 1}`}
                style={{ width: image === this.state.currentImage ? 'auto' : '0' }}
                className={`${styles.image} ${image === this.state.currentImage ? styles.activeImage : ''}`}
            >
                <ReactImageZoom
                    width={279}
                    height={340}
                    zoomWidth={540}
                    img={image}
                    zoomStyle="border: 1px solid #000; opacity: 0; background-color: white;"
                    zoomLensStyle="border: 1px solid #000; opacity: 0; background-color: gray;"
                />
            </li>
        ));

        const getProductDescriptionMarkup = () => ({ __html: productDescription });

        return (
            <Layout>
                <div className={styles.productShow}>
                    <div className={styles.productContent}>
                        <div className={`container ${styles.productContainer}`}>
                            {/* TODO: Breadcrumb */}
                            <div className={styles.breadcrumbContent}>
                                <div className="hidden-sm hidden-md hidden-lg breadcrumb-xs" />
                            </div>
                            <section className={styles.productResume}>
                                {this.props.displayLoader ? (
                                    <div className={styles.overlay}>
                                        <div className={`row ${styles.loadingHolder}`}>
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <h4 className={styles.loadingText}>
                                                    <FormattedMessage id="loading-please-wait" defaultMessage="Loading, please wait" />
                                                </h4>
                                                <div className={loadingStyles.spinnerDark} />
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="row">
                                        <div className="col-md-5 col-xs-12">
                                            {this.getCategory() && <CategoryBadge isShowProduct label={this.getCategory()} color="#FE6902" />}
                                            <div>
                                                <div className={styles.imgMain}>
                                                    <div className={styles.mainImage}>
                                                        {!this.state.defaultImage && (
                                                            <div className={`${styles.zoomHolder} ${this.state.showZoom && styles.zoomActived}`} onClick={this.toggleShowZoom}>
                                                                <i className="pe pe-7s-search" />
                                                            </div>
                                                        )}
                                                        <div className={styles.imageWrapper}>
                                                            <div className={styles.imageViewport}>
                                                                <ul className={styles.imageSlider}>{images.length > 0 ? imageList : <img src={noImage} alt={productName} />}</ul>
                                                            </div>
                                                        </div>
                                                        <div className={styles.imgLoadingContainer} style={{ display: this.state.loadingImage ? 'block' : 'none' }}>
                                                            <div className={loadingStyles.spinnerDark} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style={{ marginTop: '10px' }}>
                                                    {this.state.images && <ThumbnailList images={this.state.imageThumbs} onClickThumbnail={this.onClickThumbnail} />}
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`col-md-6 col-xs-12 ${styles.resume}`}>
                                            <form className={`form-horizontal ${styles.form}`}>
                                                <h2 className={`${styles.productName}`}>{productName}</h2>
                                                {currentProduct && currentProduct.variants && currentProduct.variants.length > 1 && (
                                                    <div>
                                                        <div>
                                                            <FormattedMessage id="selected-variant" defaultMessage="Selected variant" />
                                                            :&nbsp;
                                                            <VariantSelector
                                                                variants={currentProduct.variants}
                                                                currentVariant={currentVariant}
                                                                onVariantSelected={(variant) => {
                                                                    this.onChangeVariant(variant);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                )}
                                                <div className={`${styles.flexDisplay}`}>
                                                    {this.state.rating > 0 && (
                                                        <div className={styles.productRating}>
                                                            <div className={`row ${styles.ratingDirective}`}>
                                                                <div className={`col-lg-12 col-md-12 col-sm-12 col-xs-12 ${styles.noPadding}`}>
                                                                    <div style={{ display: 'inline-block' }}>
                                                                        <div className={styles.ratingHolder}>
                                                                            <div className={styles.ratings}>
                                                                                <div className={styles.emptyStars} />
                                                                                <div className={styles.fullStars} style={{ width: `${this.state.rating}%` }} />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    <p className={styles.reviewCount}>
                                                        {this.state.reviews > 0 && (
                                                            <span>
                                                                <span className={styles.margins}>{this.state.reviews}</span>
                                                                <FormattedMessage id="reviews" defaultMessage="Reviews" />
                                                                <span className={styles.margins}>|</span>
                                                            </span>
                                                        )}
                                                        <span className={styles.firstCommentLink}>
                                                            {/* <FormattedMessage */}
                                                            {/*    id="be-the-first-to-comment" */}
                                                            {/*    defaultMessage="Be the first to comment" */}
                                                            {/* /> */}
                                                        </span>
                                                    </p>
                                                </div>
                                                <hr className={styles.separator} />
                                                <div className={styles.priceDetails}>
                                                    <div className={styles.priceP}>
                                                        <div className="row">
                                                            <div className="col-sm-6">
                                                                <span className={styles.propertyTitle}>
                                                                    <FormattedMessage id="price-details" defaultMessage="Price Details" />
                                                                </span>
                                                                <span className={styles.price}>{priceFormat.format(this.state.currentPrice)}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <hr className={styles.separator} />
                                                <div className={styles.inStock}>
                                                    <p>
                                                        <span className={styles.propertyTitle}>
                                                            {currentProduct.attributes && currentProduct.attributes.in_stock ? (
                                                                <FormattedMessage id="in-stock" defaultMessage="In Stock" />
                                                            ) : (
                                                                <span className={styles.outStock}>
                                                                    <FormattedMessage id="out-of-stock" defaultMessage="Out Stock" />
                                                                </span>
                                                            )}
                                                        </span>
                                                        <br />
                                                        {currentProduct.attributes && currentProduct.attributes.in_stock && (
                                                            <span className={styles.estimatedArrivalTime}>
                                                                {'- '}
                                                                <FormattedMessage id="estimated-arrival-time" defaultMessage="Estimated arrival time" />
                                                                {': '}
                                                                <Link to={APP_ROUTES.shipping}>
                                                                    <FormattedMessage id="shipping-policy-link-text" defaultMessage="See delivery policy and rates" />
                                                                </Link>
                                                            </span>
                                                        )}
                                                    </p>
                                                </div>
                                                <div className={styles.itemDetails}>
                                                    <p>
                                                        <span className={styles.propertyTitle}>
                                                            <FormattedMessage id="description" defaultMessage="Description" />
                                                        </span>
                                                    </p>
                                                    <p className={styles.itemDetailsContent} dangerouslySetInnerHTML={getProductDescriptionMarkup()} />
                                                </div>
                                                {productNotes && (
                                                    <div className={styles.itemDetails}>
                                                        <p>
                                                            <span className={styles.propertyTitle}>
                                                                <FormattedMessage id="note" defaultMessage="Note" />
                                                            </span>
                                                        </p>
                                                        <p className={styles.itemDetailsContent}>{productNotes}</p>
                                                    </div>
                                                )}
                                                <hr className={styles.separator} />
                                                <ProductDetailsQuantitySelector
                                                    productPrice={this.state.currentPrice}
                                                    productAgeValid={productAgeValid}
                                                    addingProductToCart={this.props.order.addingProductToCart}
                                                    dataExtraType={this.state.dataExtraType}
                                                    onAddProductToCart={(quantity) => {
                                                        this.addProductToCart(quantity);
                                                    }}
                                                />
                                            </form>
                                        </div>
                                    </div>
                                )}
                            </section>
                        </div>
                    </div>
                </div>
                {this.state.showExtraDataModal && (
                    <ExtraDataModal
                        fieldType={this.state.extraDataInfo.fieldType}
                        label={this.state.extraDataInfo.label}
                        isRequired={this.state.extraDataInfo.isRequired}
                        onResponse={(response, value) => {
                            this.onModalResponse(response, value);
                        }}
                    />
                )}
            </Layout>
        );
    }
}

export default injectIntl(ProductShow);



/** WEBPACK FOOTER **
 ** ./src/components/pages/show-product.jsx
 **/